export const displayCategory = (category) => {
  switch (category) {
    case "tshirts":
      return "T-shirts"
    case "hoodies":
      return "Trøjer"
    case "jackets":
      return "Jakker"
    case "jeans":
      return "Bukser"
    case "shirts":
      return "Skjorter"
    case "bags":
      return "Tasker"
    case "accessories":
      return "Accessories"
    case "underwear":
      return "Undertøj"
    case "sport":
      return "Sport"
    case "shoes":
      return "Sko"
    default:
      return "Alle"
  }
}
